// 引入 axios
import axios from "axios";



let base = process.env.VUE_APP_API_BASE || '';

// 将图片URL解析为可访问的路径
// 外部CDN链接 https://download.youpucq.com/static/upload/image/xxx.jpg 转为本地 /article/xxx.jpg
// 已经是本地相对路径的 /article/xxx.jpg 直接返回
export const resolveImgUrl = (url) => {
    if (!url) return ''
    if (url.startsWith('http://') || url.startsWith('https://')) {
        if (url.includes('download.youpucq.com')) {
            const filename = url.substring(url.lastIndexOf('/') + 1)
            return '/article/' + filename
        }
        return url
    }
    return url
}

// 处理富文本HTML中的图片URL，将外部CDN链接替换为本地路径
export const resolveContentHtml = (html) => {
    if (!html) return ''
    return html.replace(
        /https?:\/\/download\.youpucq\.com\/static\/upload\/image\/[^"'\s)]+/g,
        (match) => {
            const filename = match.substring(match.lastIndexOf('/') + 1)
            return '/article/' + filename
        }
    )
}

//传送json格式的get请求
export const getRequest=(url,params)=>{
    return axios({
        method:'get',
        url:`${base}${url}`,
        data: params,
    })
}

//post请求
export const postRequest=(url,data)=>{
    return axios({
        method:'post',
        url:`${base}${url}`,
        data: data,
        headers:{'Content-Type':'application/json'},
    })
}

//put请求
export const putRequest=(url,data)=>{
    return axios({
        method:'put',
        url:`${base}${url}`,
        data: data,
        headers:{'Content-Type':'application/json'},
    })
}

//delete请求
export const deleteRequest=(url)=>{
    return axios({
        method:'delete',
        url:`${base}${url}`,
    })
}

//文件上传
export const uploadFileRequest=(url,file,module)=>{
    let formData = new FormData();
    formData.append('file', file);
    if(module) formData.append('module', module);
    return axios({
        method:'post',
        url:`${base}${url}`,
        data: formData,
        headers:{'Content-Type':'multipart/form-data'},
    })
}
